var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import { SVG404 } from './shapes';
import { persimmon } from './colors';
export default class FourOhFour extends PureComponent {
    render() {
        const _a = this.props, { message, style, className } = _a, rest = __rest(_a, ["message", "style", "className"]);
        return (React.createElement("div", Object.assign({ style: Object.assign({ textAlign: 'center' }, style), className: className }, rest),
            React.createElement("div", { style: { maxWidth: '550px', margin: '0 auto' } },
                React.createElement(SVG404, null)),
            React.createElement("div", { style: { maxWidth: '500px', margin: '0 auto' } },
                React.createElement("h1", { style: { color: persimmon.base } }, "404 Page Not Found"),
                message)));
    }
}
FourOhFour.propTypes = {
    message: PropTypes.node,
    className: PropTypes.string,
    style: StylePropType,
};
FourOhFour.defaultProps = {
    message: 'Oops! Something has gone wrong and the page you were looking for could not be displayed. Try the homepage.',
    className: '',
    style: {},
};
